import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "../../../components/UiComponent/Modal";
import RegisterAttendance from "./RegisterAttendance";
import RegisterTaskReport from "./RegisterTaskReport";
import { Container, Row, Col, Button, ListGroup } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Card from "../../../components/Card";
import { Link } from "react-router-dom";
import { get_branch_byId } from "../../../services/employeeApi";
import { useQuery } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { GetUserInfo, hasAccess } from "../../../utils/permissionChecker";
const BranchView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const user = GetUserInfo();
  const [attendanceData, setattendanceData] = useState();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [taskData, settaskData] = useState();
  const [taskModal, settaskModal] = useState(false);
  const ShowtaskModal = () => settaskModal(true);
  const ClosetaskModal = () => settaskModal(false);

  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const taskButtonSubmit = () => {
    ClosetaskModal();
  };
  const selectedBranch =
    location.state?.branchId || user?.employee?.branch_id || null;

  const { data, isLoading, isError, error } = useQuery(
    ["branchview", selectedBranch],
    async () => {
      const [branchDetail] = await Promise.all([
        get_branch_byId(selectedBranch),
      ]);
      return { branchDetail };
    }
  );
  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  const { branchDetail } = data;
  const branchEmployee = branchDetail.data?.employees;

  const addAttendance = (event, data) => {
    event.preventDefault();
    const newData = {
      ...data,
    };
    setattendanceData(newData);
    handleShowModal();
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="d-flex flex-wrap align-items-center justify-content-between">
              <div className="d-flex align-items-center justify-content-between">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb p-0 mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/branch">{t("branch")}</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {t("branch_view")}
                    </li>
                  </ol>
                </nav>
              </div>
              <Link
                to="/branch"
                className="btn btn-info btn-sm d-flex align-items-center justify-content-between ml-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="ml-2">{t("back")}</span>
              </Link>
            </div>
          </Col>
          <Col lg="4" className="mb-3 d-flex justify-content-between">
            <div>
              <ListGroup as="ul" className="list-style-1 mb-0">
                <ListGroup.Item
                  as="li"
                  className="d-flex justify-content-start align-items-center"
                >
                  <div className="avatar">
                    <h6>Branch Detail</h6>
                  </div>
                  <div className="list-style-detail ml-4 mr-2">
                    <h6 className="font-weight-bold">
                      {branchDetail?.data?.name}
                    </h6>
                    <p className="mb-0 mt-1 text-muted">
                      {branchDetail?.data?.phone}
                    </p>
                    <p className="mb-0 mt-1 text-muted">
                      {branchDetail?.data?.location}
                    </p>
                    <div>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => history.push("/employee-attendance")}
                        style={{ margin: "1.5px" }}
                      >
                        {t("attendance")}
                      </Button>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={(e) => addAttendance(e, branchEmployee)}
                      >
                        {t("add_new_attendance")}
                      </Button>
                    </div>
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </div>
          </Col>
          <Col lg="4" className="mb-3 d-flex justify-content-between">
            <div>
              <ListGroup as="ul" className="list-style-1 mb-0">
                <ListGroup.Item
                  as="li"
                  className="d-flex justify-content-start align-items-center"
                >
                  <div className="avatar">
                    <h6>Branch Manager</h6>
                  </div>
                  <div className="list-style-detail ml-4 mr-2">
                    <h6 className="font-weight-bold">
                      {branchDetail?.data?.manager?.first_name}{" "}
                      {branchDetail?.data?.manager?.father_name}
                    </h6>
                    <p className="mb-0 mt-1 text-muted">
                      {branchDetail?.data?.manager?.phone}
                    </p>
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Card>
              <Card.Body className="p-0">
                <div className="table-responsive">
                  <table className="table data-table mb-0">
                    <thead className="table-color-heading">
                      <tr className="text-muted">
                        <th scope="col">{t("name")}</th>
                        <th scope="col">{t("phone")} </th>
                        <th scope="col">{t("gender")}</th>
                        <th scope="col">{t("department")}</th>
                        <th scope="col">{t("status")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {branchEmployee.map((data) => (
                        <tr>
                          <td>
                            {data.first_name} {data.father_name}
                          </td>
                          <td>{data.phone}</td>
                          <td>{data.sex}</td>
                          <td>{data.department}</td>
                          <td>
                            {data.status ? (
                              <span className="badge bg-success">Active</span>
                            ) : (
                              <span className="badge bg-danger">
                                Not Active
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <CustomModal
          show={showModal}
          title="attendance_registration_form"
          onHide={handleCloseModal}
          centered={true}
          backdrop="static"
          keyboard={false}
          content={
            <RegisterAttendance
              onSubmitButton={handleButtonSubmit}
              attendanceData={attendanceData}
            />
          }
        />
        <CustomModal
          show={taskModal}
          title="registration_form"
          onHide={ClosetaskModal}
          centered={true}
          backdrop="static"
          keyboard={false}
          content={
            <RegisterTaskReport
              onSubmitButton={taskButtonSubmit}
              taskData={taskData}
            />
          }
        />
      </Container>
    </>
  );
};
export default BranchView;
